import React from 'react';
import { styled } from '@ff/ui';
import SkeletonLoader from '@ff/ui/Skeleton/SkeletonLoader';

export default function SectionIntroLoader() {
  return (
    <Container>
      <SkeletonLoader variant="rectangular" width="60%" height={60} />
      <TextLoader>
        <SkeletonLoader variant="text" height={35} />
        <SkeletonLoader variant="text" height={35} />
        <SkeletonLoader variant="text" height={35} />
        <SkeletonLoader variant="text" height={35} />
        <SkeletonLoader variant="text" height={35} />
        <SkeletonLoader variant="text" height={35} />
        <SkeletonLoader variant="text" height={35} />
        <SkeletonLoader variant="text" height={35} />
      </TextLoader>
    </Container>
  );
}

const Container = styled.Box(({ theme }) => ({
  padding: '180px 36px 72px 36px',
  width: '100%',
  height: '100%',
  minHeight: '100vh',
  [theme.mediaQueries.minWidth('961px')]: {
    width: '50%',
  },
}));

const TextLoader = styled.Box({
  marginTop: '20px',
});
